import React from "react";
import { Box, CardHeader, Typography, Skeleton } from "@mui/material";
import { sxStyles } from "./ProfileHeader.styles";
import { ProfileHeaderProps } from "./ProfileHeader.types";
import { useAppSelector } from "lib/redux/hooks";
import { selectUser } from "lib/redux/user/selectors";

const ProfileHeader = ({ title }: ProfileHeaderProps) => {
  const classes = sxStyles();
  const { patientName: name, isLoading } = useAppSelector(selectUser);

  return (
    <Box sx={classes.paymentPage}>
      <Box sx={classes.profileHeader}>
        {isLoading ? (
          <CardHeader
            title={<Skeleton variant="text" animation="wave" width="60%" />}
            sx={classes.cardHeader}
          />
        ) : name ? (
          <Typography sx={classes.profileName}>
            {name && name}
            {title}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default ProfileHeader;
